import { createFileRoute } from '@tanstack/react-router';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading } from '@/components/Loading';
import { activeConfig } from '@/config';
import PeerSupportCommunityPage from '@/components/pages/services/peerSupportCommunity';

const ProtectedPeerSupportCommunityPage = withAuthenticationRequired(
  PeerSupportCommunityPage,
  {
    onRedirecting: () => <Loading />,
  }
);

export const Route = createFileRoute('/services/peerSupportCommunity')({
  head: () => ({
    meta: [
      { title: `Peer Support Community | ${activeConfig.branding.appName}` },
    ],
  }),
  component: ProtectedPeerSupportCommunityPage,
});
